import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

// models
import { IOnboardingModalData } from '../../models/onBoardingModalData';

// services
import { MixpanelService } from '../../services/mixpanel.service';

@Component({
    selector: 'app-onboarding-modal',
    templateUrl: './onboarding-modal.component.html',
    styleUrls: ['./onboarding-modal.component.scss'],
    standalone: false
})
export class OnboardingModalComponent implements OnInit {

	public settings: IOnboardingModalData;

	constructor(
		@Inject(MAT_DIALOG_DATA) private data: IOnboardingModalData,
		private dialogRef: MatDialogRef<OnboardingModalComponent>,
		private mixpanelService: MixpanelService
	) {
		this.dialogRef
			.beforeClosed()
			.subscribe((result: boolean) => {
				if (result === undefined) this.close();
			});
	}

	ngOnInit(): void {
		this.settings = this.data;
	}

	apply(): void {
		this.mixpanelService.trackPage(this.settings.mixpanelEvent, { event: 'APPLY' });
		this.dialogRef.close(true);
	}

	cancel(): void {
		this.mixpanelService.trackPage(this.settings.mixpanelEvent, { event: 'CANCEL' });
		this.dialogRef.close(false);
	}

	close(): void {
		this.mixpanelService.trackPage(this.settings.mixpanelEvent, { event: 'CLOSE' });
		this.dialogRef.close(false);
	}
}